module.exports = __webpack_public_path__ + "img/home_9.fb882f4d.png";